import styled from '@emotion/styled'

const SectionContainer = styled('div')`
  margin: ${props => props.theme.spacing.base} ${props =>
  props.theme.spacing['12']};
  ${props => (props.help ? 'font-style: italic;' : '')}
  ${props =>
    props.help ? `color: ${props.theme.color.monochrome.black};` : ''}
  ${props => (props.help ? `font-size: 12px;` : '')}
`

const Label = styled('div')`
  margin-bottom: ${props => props.theme.spacing['5']};
`

const Section = ({ children, label, help }) => (
  <SectionContainer help={help}>
    {label && <Label>{label}</Label>}
    {children}
  </SectionContainer>
)

export default Section
